import '@popperjs/core';
import 'bootstrap/dist/js/bootstrap.min.js';
import '../assets/scripts/common/common.js';
import './scripts/layout/mega-menu.js';
import './scripts/layout/wysiwyg.js';
import './scripts/layout/video-modal.js';
import './scripts/layout/gtranslate.js';
import './scripts/layout/paid-membership-pro.js';
//import './scripts/layout/empty-links.js';
